export const CurrencyFormatter = (num) => {
  return Number(num).toLocaleString("en-GH", {
    currency: "GHS",
    style: "currency",
  });
};
